module.exports = __webpack_public_path__ + "static/img/p23.faa5e05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p23.jpg
// module id = 82
// module chunks = 1